import React, { useContext, useState } from 'react';
import { LoginContext } from '../../Contexts/LoginContext';
import { CategoryContext } from '../../Contexts/CategoryContext';
import { Link, useNavigate } from 'react-router-dom';
import Hero from '../../Components/buyer/Home/Hero';
import VendorsRow from '../../Components/buyer/Home/VendorsRow';
import ArticlesRow from '../../Components/buyer/Home/ArticlesRow';
import FAQsRow from '../../Components/buyer/Home/FAQsRow';
import BannersCarousel from '../../Components/buyer/Home/BannersCarousel';
import NearbyPostings from '../../Components/buyer/Home/NearbyPostings';
import GuestHomeSections from '../../Components/buyer/Home/GuestHomeSections';
import CategoryRow from '../../Components/buyer/CategoryRow';
import HomeBanner from "../../images/pngs/HomeBanner.png";
import HomeBanner2 from "../../images/pngs/HomeBanner2.png";
import { FaArrowRight, FaUserEdit, FaTimes } from 'react-icons/fa';
import SEO from '../../Components/utils/SEO';
import { SEO_SITE_NAME, SEO_SITE_URL, SEO_DEFAULT_IMAGE } from '../../config/seoConfig';

const bannerGradients = {
    'Food, Sweets & Drinks': 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    'Gift Baskets': 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    'Bouquets': 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    'Gift Items': 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    'Services': 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    'Event Accessories & Equipment': 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
};

const Home = () => {
    const { isLogin, isProfileIncomplete } = useContext(LoginContext);
    const { categories } = useContext(CategoryContext);
    const [bannerDismissed, setBannerDismissed] = useState(false);
    const navigate = useNavigate();

    const schema = [
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: SEO_SITE_NAME,
            url: SEO_SITE_URL,
            logo: SEO_DEFAULT_IMAGE
        },
        {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: SEO_SITE_NAME,
            url: SEO_SITE_URL,
            potentialAction: {
                "@type": "SearchAction",
                target: `${SEO_SITE_URL}/products-services?query={search_term_string}`,
                "query-input": "required name=search_term_string"
            }
        }
    ];

    return (
        <div className="homePage">
            <SEO
                title="Marketplace for sweets, gifts, and services"
                description="Discover sweets, gifts, services, and wholesale listings on Chocowi. Shop from trusted sellers and verified suppliers with curated categories and deals."
                canonicalPath="/"
                schema={schema}
            />
            {isLogin && isProfileIncomplete && !bannerDismissed && (
                <section className="mainSection">
                    <div className="profileCompletionBanner">
                        <div className="bannerIconWrapper">
                            <FaUserEdit className="bannerIcon" />
                        </div>
                        <div className="bannerContent">
                            <h3 className="bannerTitle">Complete Your Profile</h3>
                            <p className="bannerDescription">
                                Your profile is incomplete. Add your details so we can match you with the best sellers near you.
                            </p>
                        </div>
                        <Link to="/completeProfile" className="bannerCta">
                            Complete Now <FaArrowRight />
                        </Link>
                    </div>
                </section>
            )}
            <Hero />
            {!isLogin && (
                <section className="whyChooseUsSection">
                    <section className="mainSection">
                        <div className='scrollable-row'>
                            <div className="heading-container">
                                <h2 className='homeSectionTitle'>Why Choose Us</h2>
                            </div>
                        </div>
                        <img src={HomeBanner} className="homeBannerImg selectDisable" draggable={false} alt="Why Choose Us" />
                    </section>
                </section>
            )}
            {isLogin && (
                <section className="featuredSection">
                    <section className="mainSection">
                        <div className="homeBannerAfterLogin">
                            <div className="featuredSectionLeft">
                                <Link to="/categories" className="featuredSectionBtn">See Categories <FaArrowRight /></Link>
                                <p>Dive into our diverse selection of sweets and treats</p>
                            </div>
                            <img src={HomeBanner2} className="homeBannerImg2 selectDisable" draggable={false} alt="Featured" />
                        </div>
                    </section>
                </section>
            )}
            {/* Modern category cards section */}
            <section className="categorySection mainSection">
                <div className="scrollable-row">
                    <div className="heading-container">
                        <h2 className='homeSectionTitle'>Browse by Category</h2>
                    </div>
                </div>
                <div className="homeCatGrid">
                    {categories.map(cat => (
                        <div
                            key={cat._id || cat.name}
                            className="homeCatCard"
                            onClick={() => navigate(`/products-services?category=${encodeURIComponent(cat.name)}`)}
                        >
                            <div className="homeCatCardIcon" style={{ background: bannerGradients[cat.name] || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                                <span>{cat.icon}</span>
                            </div>
                            <div className="homeCatCardInfo">
                                <h4>{cat.name}</h4>
                                <p>{cat.subcategories?.length || 0} subcategories</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="seeAllBtnWrapper">
                    <Link to={"/categories"} className='seeAllBtn'>See All Categories <FaArrowRight /></Link>
                </div>
            </section>
            {isLogin ? <NearbyPostings /> : <GuestHomeSections />}
            <VendorsRow />
            <FAQsRow />
            <ArticlesRow />
            <BannersCarousel />

        </div>
    );
};

export default Home;